import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Editor from "../../components/Editor";
import InputFieldDebounce from "../../components/ui/InputFieldDebounce";

const VariationForm = ({
  eventData,
  onDataChange,
  onChangeMentionedMembers,
  validationErrors,
  editorInputDescriptionRef,
}) => {
  const { t } = useTranslation();

  const members = useSelector((state: any) => state.projectReducer.getIn(["project", "members"]));

  const handleChangeField = (fieldId, fieldValue) => {
    onDataChange(fieldId, fieldValue);
  };

  return (
    <div className="min-w-2xl space-y-4">
      <div>
        <InputFieldDebounce
          label={t("Variation name")}
          placeholder={t("Type...")}
          value={eventData.summary}
          onChange={(value) => handleChangeField("summary", value)}
          errorMessage={validationErrors.summary}
        />
      </div>
      <div>
        <div className="w-full">
          <label className="block text-sm font-semibold text-gray-800 mb-2">
            {t("Description")}
          </label>
          <div className="max-w-2xl rounded-lg border border-gray-300 [&_.ql-container]:!border-0">
            <Editor
              editorInputRef={editorInputDescriptionRef}
              showToolbar={false}
              minRows={4}
              members={members}
              editorContent={{
                htmlContent: eventData.description,
                contents: {},
              }}
              onChange={(content) => {
                onChangeMentionedMembers(content.mentionedMembers);
                handleChangeField("description", content.htmlContent);
              }}
            />
          </div>
          {validationErrors.description && (
            <p className="text-xs text-red-600 mt-1">{validationErrors.description}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default VariationForm;
